import type { BlockTruncatedTextBox } from 'types/block-truncated-text-box';

import React, { useEffect, useState } from 'react';
import { Wrap, Button } from '@leafwell/components';
import { useWordPressContext } from 'contexts/wordpress-provider';
import HeadingBody from './heading-body';
import WysiwygContent from './wysiwyg-content';

const TruncatedTextBox: React.FC<BlockTruncatedTextBox> = ({
  sectionId,
  instanceId,
  title,
  content,
  expandButtonLabel,
}) => {
  const { translations } = useWordPressContext();

  const [opened, toggleText] = useState(false);
  const [isTextClamped, setIsTextClamped] = useState(false);

  useEffect(() => {
    setIsTextClamped(content?.length > 114);
  }, []);

  return (
    <Wrap
      className="!py-6 md:!py-8"
      id={sectionId}
      itemID={`Sources-${instanceId}`}
    >
      {title?.length > 0 ? (
        <HeadingBody level="4" tagName="h3" title={title} className="" />
      ) : null}
      {content?.length > 0 ? (
        <WysiwygContent
          content={content}
          className={
            !opened && isTextClamped ? 'line-clamp-4 mask-clamped-text' : ''
          }
        />
      ) : null}
      {isTextClamped && (
        <Button
          className="w-fit justify-self-center"
          variant="secondary"
          filled={true}
          rounded={true}
          onClick={() => toggleText(!opened)}
          aria-hidden="true"
          label={
            opened
              ? translations['Read less']
              : expandButtonLabel?.length > 0
              ? expandButtonLabel
              : translations['Read more']
          }
        />
      )}
    </Wrap>
  );
};

export default TruncatedTextBox;
